import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <h1 className="text-6xl font-heading font-bold text-text-tertiary mb-4">404</h1>
      <p className="text-lg text-text-secondary mb-8">Deze pagina bestaat niet of is verplaatst.</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent text-text-inverse rounded-sm font-medium hover:bg-accent-hover transition-colors duration-fast"
      >
        <Home size={16} /> Naar dashboard
      </Link>
    </div>
  );
}

export default NotFound;
